module.exports = __webpack_public_path__ + "img/pic1.ea63ea47.png";